module.exports = __webpack_public_path__ + "img/feature-phone.9e860208.png";